// extracted by mini-css-extract-plugin
module.exports = {"text":"CmsText-module--text--bb8c1c"};